module.exports = __webpack_public_path__ + "fonts/montserrat-latin-300.00b3e89.woff2";